import styled from 'styled-components';

export const MaintButton = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  flex: none;
  height: 117px;
  width: 200px;
  background: transparent;
  z-index: ${props => props.style && props.style.zIndex};
`;
